var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33049 0H14.6695C18.0705 0 19.9905 1.929 20.0005 5.33V14.67C20.0005 18.07 18.0705 20 14.6695 20H5.33049C1.92949 20 0.000488281 18.07 0.000488281 14.67V5.33C0.000488281 1.929 1.92949 0 5.33049 0ZM10.0495 15.86C10.4805 15.86 10.8395 15.54 10.8795 15.11V4.92C10.9195 4.61 10.7705 4.299 10.5005 4.13C10.2195 3.96 9.87949 3.96 9.61049 4.13C9.33949 4.299 9.19049 4.61 9.21949 4.92V15.11C9.27049 15.54 9.62949 15.86 10.0495 15.86ZM14.6505 15.86C15.0705 15.86 15.4295 15.54 15.4805 15.11V11.83C15.5095 11.509 15.3605 11.21 15.0895 11.04C14.8205 10.87 14.4805 10.87 14.2005 11.04C13.9295 11.21 13.7805 11.509 13.8205 11.83V15.11C13.8605 15.54 14.2195 15.86 14.6505 15.86ZM6.21949 15.11C6.17949 15.54 5.82049 15.86 5.38949 15.86C4.95949 15.86 4.59949 15.54 4.56049 15.11V8.2C4.53049 7.889 4.67949 7.58 4.95049 7.41C5.21949 7.24 5.56049 7.24 5.83049 7.41C6.09949 7.58 6.25049 7.889 6.21949 8.2V15.11Z",
    fill: "#1AC073"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.d2457e3ce636ac584daca963242e3d42.svg";
export { ForwardRef as ReactComponent };